<template>
  <div>
    <world-nav/>
    <b-form>
      <b-form-group id="name" label="異世界名">
        <b-form-input type="text" v-model="innerValue.world.name" 
          :state="nameState" aria-describedby="input-name-help"
        />
        <b-form-invalid-feedback id="input-name-help">
          １字以上１０字以内
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="lv" label="異世界レベル"
        description="エリアレベルの最大値になります">
        <b-container>
          <b-row>
            <b-col cols="10">
              <b-form-input v-model="innerValue.world.lv" 
                type="range" min="0" max="99" />
            </b-col>
            <b-col cols="2">
              Lv{{innerValue.world.lv}}
            </b-col>
          </b-row>
        </b-container>
      </b-form-group>

      <b-form-group id="nextUpdate" label="次回更新日">
        <b-form-datepicker v-model="nextUpdate"
          value-as-date :min="new Date(Date.now())" />
        <b-container>
          <b-row cols="9">
            <b-form-input v-model="innerValue.world.timerDay" 
              type="range" min="0" max="14" />
          </b-row>
          <b-row>次回は{{ innerValue.world.timerDay }}日後に自動設定</b-row>
        </b-container>
      </b-form-group>

      <b-form-group id="notice" label="概要">
        <remark-editor v-model="innerValue.world.note"
          :danger="1000" :warn="800" />
      </b-form-group>

      <b-form-group id="image" label="イメージ">
        <b-form-input v-model="innerValue.world.bg" debounce="500"></b-form-input>
        <b-img :src="innerValue.world.bg" width="250px" height="75px" fluid></b-img>
      </b-form-group>

      <b-form-group id="start" label="初期位置"
        description="キャラ登録時にこの世界が選択された場合の初期位置を指定します。">
        <div v-for="s in innerValue.world.start" :key="s">
          {{ innerValue.area[s].name }}
          <b-button variant="danger" @click="deleteStart(s)">
            <font-awesome-icon icon="times" class="icon fa-1x" />
          </b-button>
        </div>
        <b-input-group>
          <b-form-select v-model="newStartValue" 
            :options="areas" />
          <b-input-group-append>
            <b-button @click="newStart">
              <font-awesome-icon icon="plus-square" class="fa-1x p-0" />
              追加
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group id="openCharacter" label="キャラクター登録"
        description="サブキャラ登録画面の世界一覧でこの世界が選択可能になります。">
        <b-form-checkbox v-model="innerValue.world.openEntry"
          :value="1" :unchecked-value="null">
          サブキャラクターを登録可能にする
        </b-form-checkbox>
      </b-form-group>

      <b-form-group id="end" label="クリア条件"
        description="特定のステータスを獲得した時にクリアしたと見なし、不奇跡世界で特別な実績を得ます。">
        <b-form-input v-model="innerValue.world.end" />
      </b-form-group>

      <b-form-group id="openCard" label="カード公開"
        description="作成したカード・異常状態を他の世界で共有します。この設定は更新処理で適用されます。">
        <b-form-checkbox v-model="innerValue.world.openCard"
          :value="1" :unchecked-value="null">
          作成済みカード・異常状態を公開する
        </b-form-checkbox>
      </b-form-group>

      <b-form-group id="importCard" label="カード取込">
        <div v-for="s in innerValue.world.importCard" :key="s">
          {{ worldsMap[s].name }}
          <b-button variant="danger" @click="deleteImportCard(s)">
            <font-awesome-icon icon="times" class="icon fa-1x" />
          </b-button>
        </div>
        <b-input-group>
          <b-form-select v-model="newImportCardValue" 
            :options="openCardWorldsSelect"
            />
          <b-input-group-append>
            <b-button @click="newImportCard">
              <font-awesome-icon icon="plus-square" class="fa-1x p-0" />
              追加
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-button type="button" variant="primary" @click="$emit('submit')">登録</b-button>
      <response-message ref="response" :value="postMessage" />
    </b-form>
  </div>
</template>

<script>
import WorldNav from '@/components/WorldNav'
import ResponseMessage from '@/components/ResponseMessage'
import RemarkEditor from '@/components/RemarkEditor'
import mixinPlayer from './mixin-player'
import { areas, worlds } from './mixin-editor'
import _ from 'lodash'
export default {
  components: {
    WorldNav,
    ResponseMessage,
    RemarkEditor
  },
  mixins: [mixinPlayer, areas, worlds],
  computed: {
    nextUpdate: {
      get() { return new Date(this.innerValue.world.nextUpdate*1000) },
      set(v) { this.innerValue.world.nextUpdate = new Date(v).getTime()/1000 }
    },
    nameState () { return this.innerValue.world.name
      && this.innerValue.world.name.length > 0 
      && this.innerValue.world.name.length <= 10 }
  },
  props: {
    value: Object,
    postMessage: Object,
  },
  data () {
    return {
      innerValue: this.value,
      newStartValue: null,
      newImportCardValue: null,
    }
  },
  methods: {
    newStart () {
      if(this.newStartValue && _.indexOf(this.innerValue.world.start, this.newStartValue) == -1){
        this.innerValue.world.start.push(this.newStartValue)
        this.newStartValue = null
      }
    },
    deleteStart (v) {
      this.innerValue.world.start
        = _.filter(this.innerValue.world.start, _v=>_v!=v)
    },
    newImportCard () {
      if(this.newImportCardValue && _.indexOf(this.innerValue.world.importCard, this.newImportCardValue) == -1){
        this.innerValue.world.importCard.push(this.newImportCardValue)
        this.newImportCardValue = null
      }
    },
    deleteImportCard (v) {
      this.innerValue.world.importCard
        = _.filter(this.innerValue.world.importCard, _v=>_v!=v)
    },
  },
  mounted () {
  },
  watch: {
    innerValue (val) {
      this.$emit('input', val)      
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
